import {configureStore} from "@reduxjs/toolkit";
import {reducer as toastrReducer} from "react-redux-toastr";
import webSocketReducer from './store/webSockets/WebSockets.slice';
import activeGameScoreReducer from './store/pages/activeGameScore/toolkit/activeGameScoreSlice';
import shootOutActiveGameScoreReducer from './store/pages/shootOutActiveGameScore/shootOutActiveGameScoreSlice';
import liveScoreInfoReducer from './store/pages/liveScoreInfo/liveScoreInfoSlice';
import postMatchReducer from './store/pages/postMatch/postMatchSlice';
import preMatchReducer from './store/pages/preMatch/preMatchSlice';
import leagueTableReducer from './store/pages/leagueTable/leagueTableSlice';
import scoreboardStatsReducer from './store/pages/scoreboardAndStats/scoreboardAndStatsSlice';
import cmsAdcGamesReducer from './store/cms/darts/adcGames/cmsAdcGamesSlice'
import cmsShootOutGamesReducer from './store/cms/darts/shootOutGames/cmsShootOutGamesSlice';
import cmsPhasesReducer from './store/cms/darts/phases/cmsPhasesSlice';
import cmsWeeksReducer from './store/cms/darts/weeks/cmsWeeksSlice';
import cmsNewsReducer from './store/cms/modusNews/cmsModusNewsSlice';
import DartsGame from './store/dartsGame/DartsGame.slice';
import dailyResult from './store/dailyResults/dailyResultSlice';
import {createSocketMiddleware} from './socket';
import permissionsSlice from "./store/cms/permissions/permissionsSlice";
import Shared from "./screens/SendEmailForm/Shared.slice";

import General from './store/general.slice';
import Auth from './pages/Auth/Auth.slice';
import Billing from "./pages/Billing/Billing.slice";
import DartsScoring from './pages/Darts/Scoring/DartsScoring.slice';
import DartsPlayersCRUD from './pages/Darts/Players/DartsPlayersCRUD.slice';
import DartsGamesCRUD from './pages/Darts/Games/DartsGamesCRUD.slice';
import CompetitionsCRUD from './pages/Competitions/CompetitionsCRUD.slice';
import TournamentsCRUD from './pages/Tournaments/TournamentsCRUD.slice';
import UsersCRUD from './pages/Access/Users/UsersCRUD.slice';
import RolesList from './pages/Access/Roles/RolesList.slice';
import ClientsCRUD from './pages/Access/Clients/ClientsCRUD.slice';
import ListenersCRUD from "./pages/Access/Listeners/ListenersCRUD.slice";
import DartsEventManager from './pages/Darts/EventManager/DartsEventManager.slice';
import LoggingExceptions from "./pages/Logging/Exceptions/LoggingExceptions.slice";
import LoggingMessages from "./pages/Logging/Messages/LoggingMessages.slice";
import LoggingConnections from "./pages/Logging/Connections/LoggingConnections.slice";


const socketMiddleware = createSocketMiddleware();

export const rootReducer = {
    toastr: toastrReducer,
    connection: webSocketReducer,
    General,
    Auth,
    DartsEventManager,
    DartsGame,
    DartsScoring,
    scoreboardAndStats: scoreboardStatsReducer,
    activeGameScore: activeGameScoreReducer,
    shootOutActiveGameScore: shootOutActiveGameScoreReducer,
    liveScoreInfo: liveScoreInfoReducer,
    postMatch: postMatchReducer,
    preMatch: preMatchReducer,
    leagueTable: leagueTableReducer,
    cmsAdcGames: cmsAdcGamesReducer,
    DartsGamesCRUD,
    cmsShootOutGames: cmsShootOutGamesReducer,
    DartsPlayersCRUD,
    CompetitionsCRUD,
    cmsPhases: cmsPhasesReducer,
    cmsWeeks: cmsWeeksReducer,
    TournamentsCRUD,
    UsersCRUD,
    RolesList,
    ClientsCRUD,
    cmsNews: cmsNewsReducer,
    ListenersCRUD,
    permissions: permissionsSlice,
    // Logging
    LoggingExceptions, LoggingMessages, LoggingConnections,
    dailyResult,
    Billing,
    Shared
}

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(socketMiddleware),
    devTools: true,
});

export default store;


export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

